import { Routes } from '@angular/router'
import { AuthTemplateComponent } from './components/template/auth-template/auth-template.component'
import { LoginComponent } from './components/auth/login/login.component'
import { DashboardComponent } from './components/dashboard/dashboard.component'
import { eps } from './services/url.service' //endPoints
import { authGuard } from './guards/auth.guard'
// import { permissionGuard } from './guards/permissionNOld.guard'
import { permissionGuard } from './guards/permission.guard'
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component'
import { AppTemplateComponent } from './components/template/app-template/app-template.component'
import { BusinessComponent } from './components/business/business.component'
import { WrapperComponent } from './components/salary-components/wrapper/wrapper.component'
import { BusinessDetailComponent } from './components/business/business-detail/business-detail.component'
import { RegistrationComponent } from './components/auth/registration/registration.component'
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component'
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component'
import { DepartmentComponent } from './components/department/department.component'
import { DesignationComponent } from './components/designation/designation.component'
import { EmployeeComponent } from './components/employee/employee.component'
import { EmployeeDetailComponent } from './components/employee/employee-detail/employee-detail.component'
import { RolePermissionComponent } from './components/role-permission/role-permission.component'
import { EmployeeSalaryWrapperComponent } from './components/employee-salary/employee-salary-wrapper/employee-salary-wrapper.component'
import { HolidaysComponent } from './components/leaves/holidays/holidays.component'
import { LeavePoliciesComponent } from './components/leaves/leave-policies/leave-policies.component'
import { AppliedLeavesComponent } from './components/leaves/applied-leaves/applied-leaves.component'
import { LeavesRequestComponent } from './components/leaves/leaves-request/leaves-request.component'
import { AttendanceComponent } from './components/employee/attendance/attendance.component'
import { CalanderComponent } from './components/attendance/calander/calander.component'
import { AttendancePolicyComponent } from './components/attendance/attendance-policy/attendance-policy.component'
import { OfficeDetailsComponent } from './components/office/office-details/office-details.component'
import { AttendanceListComponent } from './components/attendance/attendance-list/attendance-list.component'
import { EmpDashboardComponent } from './components/employee/dashboard/dashboard.component'
import { SalaryMode } from './store/employee-salary/employee-salary.state'
import { PermissionSetsComponent } from './components/permission-sets/permission-sets.component'
import { PermissionSetDetailsComponent } from './components/permission-sets/details/details.component'
import { ManagePayrollComponent } from './components/payroll/manage-payroll/manage-payroll.component'
import { RunPayrollComponent } from './components/payroll/run-payroll/run-payroll.component'
import { PayslipWrapperComponent } from './components/payroll/payslip-wrapper/payslip-wrapper.component'
import { EmployeeRequestComponent } from './components/employee-request/employee-request.component'
import { OrgChartComponent } from './components/org-chart/org-chart.component'
import { LeavePolicyDetailComponent } from './components/leaves/leave-policies/leave-policy-detail/leave-policy-detail.component'
import { PayrollSummaryComponent } from './components/payroll/payroll-summary/payroll-summary.component'
import { InvestmentsWrapperComponent } from './components/investments/wrapper/investments-wrapper.component'
import { LeaveBalanceComponent } from './components/leaves/leave-balance/leave-balance.component'
import { TaxWrapperComponent } from './components/tax/tax-wrapper/tax-wrapper.component'
import { PlansComponent } from './components/plans/plans.component'
import { BasicComponent } from './components/planAndBilling/basic/basic.component'
import { SubscribersComponent } from './components/subscribers/subscribers.component'
import { LicenceHistoryComponent } from './components/planAndBilling/licence-history/licence-history.component'
import { PayoutAgreementWrapperComponent } from './components/payoutAgreement/payout-agreement-wrapper/payout-agreement-wrapper.component'
import { PayOutMode } from './store/payout-agreement/payout-agreement.state'
import { ManageContractorPayrollComponent } from './components/contractor-payroll/manage-contractor-payroll/manage-contractor-payroll.component'
import { RunContractorPayrollComponent } from './components/contractor-payroll/run-contractor-payroll/run-contractor-payroll.component'
import { RoleComponent } from './components/role/role.component'
import { RoleDetailComponent } from './components/role/roleDetail/role-detail.component'
import { PermissionSetComponent } from './components/permission-set/permission-set.component'
import { PermissionSetDetailComponent } from './components/permission-set/permissionSetDetail/permission-set-detail.component'
import { ContractorPayrollSummaryComponent } from './components/contractor-payroll/payroll-summary/contractor-payroll-summary.component'
import { InvoiceWrapperComponent } from './components/contractor-payroll/invoice-wrapper/invoice-wrapper.component'
import { PlanSelectionComponent } from './components/planAndBilling/plan-selection/plan-selection.component'
import { PlanChangeSummaryComponent } from './components/planAndBilling/plan-change-summary/plan-change-summary.component'
import { PaymentCallbackComponent } from './components/planAndBilling/payment-callback/payment-callback.component'
import { PaymentSuccessComponent } from './components/planAndBilling/payment-success/payment-success.component'
import { PaymentFailureComponent } from './components/planAndBilling/payment-failure/payment-failure.component'
import { ActivatePlanComponent } from './components/planAndBilling/activate-plan/activate-plan.component'
import { AddLicencePreviewComponent } from './components/planAndBilling/add-licence-preview/add-licence-preview.component'
import { BirthdaysComponent } from './components/birthdays/birthdays.component'
import { AnniversaryComponent } from './components/anniversary/anniversary.component'
import { NotificationComponent } from './notification/notification.component'
import { TeamMembersComponent } from './components/team-members/team-members.component'
import { AttendancePolicyDetailsComponent } from './components/attendance/attendance-policy/attendance-policy-details/attendance-policy-details.component'
import { OwnerDashboardComponent } from './components/business/owner-dashboard/owner-dashboard.component'

// eslint-disable-next-line no-console
console.log('app.routes urls', eps)

//19nov2025 commented
// export const routes: Routes = [
//   //  { path: '', component: HomeComponent }, // Default (Home)
//   {
//     path: eps.auth.base,
//     component: AuthTemplateComponent,
//     children: [{ path: eps.auth.login, component: LoginComponent }]
//   },
//   {
//     path: eps.auth.base,
//     component: AuthTemplateComponent,
//     children: [{ path: `${eps.auth.register}/:id`, component: RegistrationComponent }]
//   },
//   {
//     path: eps.auth.base,
//     component: AuthTemplateComponent,
//     children: [{ path: eps.auth.forgotPassword, component: ForgotPasswordComponent }]
//   },
//   {
//     path: eps.auth.base,
//     component: AuthTemplateComponent,
//     children: [{ path: eps.auth.resetPassword, component: ResetPasswordComponent }]
//   },
//   {
//     path: eps.user.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.user.dashboard,
//         component: DashboardComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { dashboard: ['view', 'edit'] } }
//       },
//       //add more paths here...
//       { path: eps.user.unauthorized, component: UnauthorizedComponent },
//       {
//         path: eps.user.employeeDashboard,
//         component: EmpDashboardComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { dashboard: ['view', 'edit'] } }
//       },
//       {
//         path: eps.user.employeeRequest,
//         component: EmployeeRequestComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//       },
//       {
//         path: eps.user.orgChart,
//         component: OrgChartComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//       }
//     ]
//   },
//   {
//     path: eps.company.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.company.business,
//         component: BusinessComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { business: ['view'] } }
//       },
//       {
//         path: `${eps.company.business}/:id`,
//         component: BusinessDetailComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { business: ['view'] } }
//       },
//       {
//         path: eps.company.salaryComponents,
//         component: WrapperComponent
//         //canActivate: [permissionGuard],
//         //data: { permissions: { dashboard1: ['view', 'edit'] } }
//       },
//       {
//         path: `${eps.company.office}/:id`,
//         component: OfficeDetailsComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { office: ['view'] } }
//       },
//       {
//         path: eps.company.department,
//         component: DepartmentComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { department: ['view'] } }
//       },
//       {
//         path: eps.company.designation,
//         component: DesignationComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { designation: ['view'] } }
//       },
//       {
//         path: eps.company.taxSettings,
//         component: TaxWrapperComponent
//       }
//     ]
//   },
//   {
//     path: eps.superAdmin.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.superAdmin.plans,
//         component: PlansComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plans: ['view'] } }
//       },
//       {
//         path: eps.superAdmin.subscribers,
//         component: SubscribersComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plans: ['view'] } }
//       },
//       {
//         path: `${eps.superAdmin.licenceHistory}/:id`,
//         component: LicenceHistoryComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plans: ['view'] } }
//       }
//     ]
//   },
//   {
//     path: eps.hrm.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.hrm.employee,
//         component: EmployeeComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { user: ['view'], employees: ['view'] } }
//       },
//       {
//         path: `${eps.hrm.employee}/:id`,
//         component: EmployeeDetailComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { user: ['view'], employees: ['view'] } }
//       },
//       {
//         path: `${eps.hrm.createSalary}/:id`,
//         component: EmployeeSalaryWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { employeeSalary: ['add'] }, mode: SalaryMode.CREATE }
//       },
//       {
//         path: `${eps.hrm.reviseSalary}/:id`,
//         component: EmployeeSalaryWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.REVISE }
//       },
//       {
//         path: `${eps.hrm.updateSalary}/:id`,
//         component: EmployeeSalaryWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.UPDATE }
//       },
//       {
//         path: `${eps.hrm.createPayout}/:id`,
//         component: PayoutAgreementWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { employeeSalary: ['add'] }, mode: PayOutMode.CREATE }
//       },
//       {
//         path: `${eps.hrm.revisePayout}/:id`,
//         component: PayoutAgreementWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.REVISE }
//       },
//       {
//         path: `${eps.hrm.updatePayout}/:id`,
//         component: PayoutAgreementWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.UPDATE }
//       },
//       {
//         path: eps.hrm.managePayroll,
//         component: ManagePayrollComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['view'] } }
//       },
//       {
//         path: eps.hrm.runPayroll,
//         component: RunPayrollComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['add', 'edit', 'delete'] } }
//       },
//       {
//         path: eps.hrm.payslip,
//         component: PayslipWrapperComponent
//         //canActivate: [permissionGuard],
//         //data: { permissions: { employeeSalary: ['edit'] } }
//       },
//       {
//         path: `${eps.hrm.payrollSummary}/:id`,
//         component: PayrollSummaryComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['view'] } }
//       },
//       {
//         path: `${eps.hrm.investments}`,
//         component: InvestmentsWrapperComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['view'] } }
//       },
//       {
//         path: eps.hrm.manageContractorPayroll,
//         component: ManageContractorPayrollComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['view'] } }
//       },
//       {
//         path: eps.hrm.runContractorPayroll,
//         component: RunContractorPayrollComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['view'] } }
//       },
//       {
//         path: `${eps.hrm.contractorPayrollSummary}/:id`,
//         component: ContractorPayrollSummaryComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { payroll: ['view'] } }
//       },
//       {
//         path: eps.hrm.invoice,
//         component: InvoiceWrapperComponent
//         //canActivate: [permissionGuard],
//         //data: { permissions: { employeeSalary: ['edit'] } }
//       }
//     ]
//   },
//   {
//     path: eps.userRole.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.userRole.role,
//         component: RolePermissionComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { userRole: ['view'] } }
//       },
//       {
//         path: eps.userRole.permissionSet,
//         component: PermissionSetsComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { userRole: ['view'] } }
//       },
//       {
//         path: `${eps.userRole.permissionsetdetails}/:id`,
//         component: PermissionSetDetailsComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { userRole: ['view'] } }
//       },
//       {
//         path: `${eps.userRole.roledetails}/:id`,
//         component: RoleDetailsComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { userRole: ['view'] } }
//       }
//     ]
//   },
//   {
//     path: eps.role.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.role.role,
//         component: RoleComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { role: ['view'] } }
//       },
//       {
//         path: `${eps.role.roledetails}/:id`,
//         component: RoleDetailComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { role: ['view'] } }
//       }
//     ]
//   },
//   {
//     path: eps.permissionSet.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.permissionSet.permissionSet,
//         component: PermissionSetComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { permissionSet: ['view'] } }
//       },
//       {
//         path: `${eps.permissionSet.permissionSetdetails}/:id`,
//         component: PermissionSetDetailComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { permissionSet: ['view'] } }
//       }
//     ]
//   },
//   {
//     path: eps.attendance.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.attendance.policies,
//         component: AttendancePolicyComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { attendancePolicy: ['view'] } }
//       },
//       {
//         path: eps.attendance.attendanceList,
//         component: AttendanceListComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { adminAttendance: ['view'] } }
//       },
//       {
//         path: `${eps.attendance.employeeAttendance}/:id`,
//         component: AttendanceComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: [{ attendance: ['view'] }, { adminAttendance: ['view'] }] }
//       },
//       {
//         path: eps.attendance.calander,
//         component: CalanderComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: [{ attendance: ['view'] }, { business: ['view'] }] }
//       }
//     ]
//   },
//   {
//     path: eps.leaves.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.leaves.holidays,
//         component: HolidaysComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { holidays: ['view'] } }
//       },
//       {
//         path: eps.leaves.policies,
//         component: LeavePoliciesComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { leavePolicy: ['view'] } }
//       },
//       {
//         path: eps.leaves.appliedLeave,
//         component: AppliedLeavesComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { leaves: ['view'] } }
//       },
//       {
//         path: eps.leaves.leavesRequest,
//         component: LeavesRequestComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { leaveRequests: ['view'] } }
//       },
//       {
//         path: `${eps.leaves.assignedPolicyDetail}/:id`,
//         component: LeavePolicyDetailComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { leavePolicy: ['view'] } }
//       },
//       {
//         path: eps.leaves.assignedPolicyBalance,
//         component: LeaveBalanceComponent,
//         data: {}
//       }
//     ]
//   },
//   {
//     path: eps.planAndBilling.base,
//     component: AppTemplateComponent,
//     canActivate: [authGuard],
//     children: [
//       {
//         path: eps.planAndBilling.plan,
//         component: BasicComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plansAndBilling: ['view'] } }
//       },
//       {
//         path: eps.planAndBilling.upgradePlan,
//         component: PlanSelectionComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plansAndBilling: ['view'] } }
//       },
//       {
//         path: `${eps.planAndBilling.changePlanSummary}/:id`,
//         component: PlanChangeSummaryComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plansAndBilling: ['view'] } }
//       },
//       {
//         path: `${eps.planAndBilling.paymentCallback}`,
//         component: PaymentCallbackComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plansAndBilling: ['view'] } }
//       },
//       {
//         path: `${eps.planAndBilling.paymentSuccess}`,
//         component: PaymentSuccessComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plansAndBilling: ['view'] } }
//       },
//       {
//         path: `${eps.planAndBilling.paymentFailure}`,
//         component: PaymentFailureComponent,
//         canActivate: [permissionGuard],
//         data: { permissions: { plansAndBilling: ['view'] } }
//       }
//     ]
//   }

//   //{ path: '**', redirectTo: '', pathMatch: 'full' }
// ]

//19nov 2025
export const routes: Routes = [
  // AUTH routes (separate layout)
  {
    path: eps.auth.base,
    component: AuthTemplateComponent,
    children: [
      { path: eps.auth.login, component: LoginComponent },
      { path: `${eps.auth.register}/:id`, component: RegistrationComponent },
      { path: eps.auth.forgotPassword, component: ForgotPasswordComponent },
      { path: eps.auth.resetPassword, component: ResetPasswordComponent },
      // default of auth base -> login
      { path: '', redirectTo: eps.auth.login, pathMatch: 'full' }
    ]
  },

  // MAIN APP layout (header/sidebar render ONCE)
  {
    path: '',
    component: AppTemplateComponent,
    canActivate: [authGuard],
    children: [
      // USER module routes (kept as same final URLs as before)
      {
        path: `${eps.user.base}/${eps.user.dashboard}`,
        component: DashboardComponent,
        canActivate: [permissionGuard],
        data: { permissions: { dashboard: ['view', 'edit'] } }
      },
      { path: `${eps.user.base}/${eps.user.unauthorized}`, component: UnauthorizedComponent },
      {
        path: `${eps.user.base}/${eps.user.employeeDashboard}`,
        component: EmpDashboardComponent,
        canActivate: [permissionGuard],
        data: { permissions: { dashboard: ['view', 'edit'] } }
      },
      {
        path: `${eps.user.base}/${eps.user.ownerDashboard}`,
        component: OwnerDashboardComponent
        // canActivate: [permissionGuard],
        // data: { permissions: { dashboard: ['view', 'edit'] } }
      },
      {
        path: `${eps.user.base}/${eps.user.employeeRequest}`,
        component: EmployeeRequestComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
      },
      {
        path: `${eps.user.base}/${eps.user.orgChart}`,
        component: OrgChartComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
      },

      // COMPANY module
      {
        path: `${eps.company.base}/${eps.company.business}`,
        component: BusinessComponent,
        canActivate: [permissionGuard],
        data: { permissions: { business: ['view'] } }
      },
      {
        path: `${eps.company.base}/${eps.company.business}/:id`,
        component: BusinessDetailComponent,
        canActivate: [permissionGuard],
        data: { permissions: { business: ['view'] } }
      },
      { path: `${eps.company.base}/${eps.company.salaryComponents}`, component: WrapperComponent },
      {
        path: `${eps.company.base}/${eps.company.office}/:id`,
        component: OfficeDetailsComponent,
        canActivate: [permissionGuard],
        data: { permissions: { office: ['view'] } }
      },
      {
        path: `${eps.company.base}/${eps.company.department}`,
        component: DepartmentComponent,
        canActivate: [permissionGuard],
        data: { permissions: { department: ['view'] } }
      },
      {
        path: `${eps.company.base}/${eps.company.designation}`,
        component: DesignationComponent,
        canActivate: [permissionGuard],
        data: { permissions: { designation: ['view'] } }
      },
      { path: `${eps.company.base}/${eps.company.taxSettings}`, component: TaxWrapperComponent },

      // SUPER ADMIN
      {
        path: `${eps.superAdmin.base}/${eps.superAdmin.plans}`,
        component: PlansComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plans: ['view'] } }
      },
      {
        path: `${eps.superAdmin.base}/${eps.superAdmin.subscribers}`,
        component: SubscribersComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plans: ['view'] } }
      },
      {
        path: `${eps.superAdmin.base}/${eps.superAdmin.licenceHistory}/:id`,
        component: LicenceHistoryComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plans: ['view'] } }
      },

      // HRM
      {
        path: `${eps.hrm.base}/${eps.hrm.employee}`,
        component: EmployeeComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ user: ['view'], employees: ['view'] }] }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.employee}/:id`,
        component: EmployeeDetailComponent,
        canActivate: [permissionGuard],
        // data: { permissions: { user: ['view'], employees: ['view'] } }
        data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
      },

      {
        path: `${eps.hrm.base}/${eps.hrm.createSalary}/:id`,
        component: EmployeeSalaryWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { employeeSalary: ['add'] }, mode: SalaryMode.CREATE }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.reviseSalary}/:id`,
        component: EmployeeSalaryWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.REVISE }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.updateSalary}/:id`,
        component: EmployeeSalaryWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.UPDATE }
      },

      {
        path: `${eps.hrm.base}/${eps.hrm.createPayout}/:id`,
        component: PayoutAgreementWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { employeeSalary: ['add'] }, mode: PayOutMode.CREATE }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.revisePayout}/:id`,
        component: PayoutAgreementWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.REVISE }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.updatePayout}/:id`,
        component: PayoutAgreementWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.UPDATE }
      },

      {
        path: `${eps.hrm.base}/${eps.hrm.managePayroll}`,
        component: ManagePayrollComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['view'] } }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.runPayroll}`,
        component: RunPayrollComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['add', 'edit', 'delete'] } }
      },
      { path: `${eps.hrm.base}/${eps.hrm.payslip}`, component: PayslipWrapperComponent },
      {
        path: `${eps.hrm.base}/${eps.hrm.payrollSummary}/:id`,
        component: PayrollSummaryComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['view'] } }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.investments}`,
        component: InvestmentsWrapperComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['view'] } }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.manageContractorPayroll}`,
        component: ManageContractorPayrollComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['view'] } }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.runContractorPayroll}`,
        component: RunContractorPayrollComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['view'] } }
      },
      {
        path: `${eps.hrm.base}/${eps.hrm.contractorPayrollSummary}/:id`,
        component: ContractorPayrollSummaryComponent,
        canActivate: [permissionGuard],
        data: { permissions: { payroll: ['view'] } }
      },
      { path: `${eps.hrm.base}/${eps.hrm.invoice}`, component: InvoiceWrapperComponent },

      // USER ROLE & PERMISSIONS
      {
        path: `${eps.userRole.base}/${eps.userRole.role}`,
        component: RolePermissionComponent,
        canActivate: [permissionGuard],
        data: { permissions: { userRole: ['view'] } }
      },
      {
        path: `${eps.userRole.base}/${eps.userRole.permissionSet}`,
        component: PermissionSetsComponent,
        canActivate: [permissionGuard],
        data: { permissions: { userRole: ['view'] } }
      },
      {
        path: `${eps.userRole.base}/${eps.userRole.permissionsetdetails}/:id`,
        component: PermissionSetDetailsComponent,
        canActivate: [permissionGuard],
        data: { permissions: { userRole: ['view'] } }
      },

      // ROLE
      {
        path: `${eps.role.base}/${eps.role.role}`,
        component: RoleComponent,
        canActivate: [permissionGuard],
        data: { permissions: { role: ['view'] } }
      },
      {
        path: `${eps.role.base}/${eps.role.roledetails}/:id`,
        component: RoleDetailComponent,
        canActivate: [permissionGuard],
        data: { permissions: { role: ['view'] } }
      },

      // PERMISSION SET
      {
        path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSet}`,
        component: PermissionSetComponent,
        canActivate: [permissionGuard],
        data: { permissions: { permissionSet: ['view'] } }
      },
      {
        path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSetdetails}/:id`,
        component: PermissionSetDetailComponent,
        canActivate: [permissionGuard],
        data: { permissions: { permissionSet: ['view'] } }
      },

      // ATTENDANCE
      {
        path: `${eps.attendance.base}/${eps.attendance.policies}`,
        component: AttendancePolicyComponent,
        canActivate: [permissionGuard],
        data: { permissions: { attendancePolicy: ['view'] } }
      },
      {
        path: `${eps.attendance.base}/${eps.attendance.attendanceList}`,
        component: AttendanceListComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ adminAttendance: ['view'] }, { attendance: ['view'] }] }
      },
      {
        path: 'attendance',
        children: [
          {
            path: 'attendance-policy-details/:policyId',
            component: AttendancePolicyDetailsComponent
          }
        ]
      },
      {
        path: `${eps.attendance.base}/${eps.attendance.employeeAttendance}/:id`,
        component: AttendanceComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ attendance: ['view'] }, { attendanceAdmin: ['view'] }] }
      },
      {
        path: `${eps.attendance.base}/${eps.attendance.calander}`,
        component: CalanderComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ attendance: ['view'] }, { business: ['view'] }] }
      },

      // LEAVES
      {
        path: `${eps.leaves.base}/${eps.leaves.holidays}`,
        component: HolidaysComponent,
        canActivate: [permissionGuard],
        data: { permissions: { holidays: ['view'] } }
      },
      {
        path: `${eps.leaves.base}/${eps.leaves.policies}`,
        component: LeavePoliciesComponent,
        canActivate: [permissionGuard],
        data: { permissions: { leavePolicy: ['view'] } }
      },
      {
        path: `${eps.leaves.base}/${eps.leaves.appliedLeave}`,
        component: AppliedLeavesComponent,
        canActivate: [permissionGuard],
        data: { permissions: { leaves: ['view'] } }
      },
      {
        path: `${eps.leaves.base}/${eps.leaves.leavesRequest}`,
        component: LeavesRequestComponent,
        canActivate: [permissionGuard],
        data: { permissions: { leaveRequests: ['view'] } }
      },
      {
        path: `${eps.leaves.base}/${eps.leaves.assignedPolicyDetail}/:id`,
        component: LeavePolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { permissions: { leavePolicy: ['view'] } }
      },
      {
        path: `${eps.leaves.base}/${eps.leaves.assignedPolicyBalance}`,
        component: LeaveBalanceComponent
      },

      // PLAN & BILLING
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.plan}`,
        component: BasicComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.upgradePlan}`,
        component: PlanSelectionComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.changePlanSummary}/:id`,
        component: PlanChangeSummaryComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentCallback}`,
        component: PaymentCallbackComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentSuccess}`,
        component: PaymentSuccessComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentFailure}`,
        component: PaymentFailureComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.activatePlan}/:id`,
        component: ActivatePlanComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.planAndBilling.base}/${eps.planAndBilling.previewAddLicences}/:id`,
        component: AddLicencePreviewComponent,
        canActivate: [permissionGuard],
        data: { permissions: { plansAndBilling: ['view'] } }
      },
      {
        path: `${eps.notifications.notifications}/:userId`,
        component: NotificationComponent,
        canActivate: [permissionGuard]
        // data: { permissions: { notifications: ['view'] } }
      },
      {
        path: `${eps.employeeManager.base}/${eps.employeeManager.teamMembers}/:id`,
        component: TeamMembersComponent,
        canActivate: [permissionGuard]
        // data: { permissions: { employeeManager: ['view'] } }
      },

      // event
      {
        path: `${eps.event.base}/${eps.event.birthdays}`,
        component: BirthdaysComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
      },
      {
        path: `${eps.event.base}/${eps.event.anniversary}`,
        component: AnniversaryComponent,
        canActivate: [permissionGuard],
        data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
      }
    ]
  },

  // default route inside app -> redirect to dashboard (adjust if necessary)
  //   { path: '', redirectTo: `${eps.user.base}/${eps.user.dashboard}`, pathMatch: 'full' }
  // ]

  // Wildcard redirect to auth (or 404 component if you prefer)
  { path: '**', redirectTo: eps.auth.base, pathMatch: 'full' }
]
